import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, input, signal } from '@angular/core';

@Component({
  selector: 'app-info-popover',
  imports: [CommonModule],
  templateUrl: './info-popover.component.html',
  styles: ``,
})
export class InfoPopoverComponent {
  public title = input<string>('Help');
  public description = input<string>('');
  public imageSrc = input<string>('');
  public imageAlt = input<string>('Help image');
  public position = input<'top' | 'bottom' | 'left' | 'right'>('bottom');
  public ariaLabel = input<string>('Show help information');
  public additionalContent = input<boolean>(false);

  public isOpen = signal(false);
  public imageLoading = signal(true);
  public imageError = signal(false);

  public headingId = `popover-heading-${Math.random().toString(36).substr(2, 9)}`;
  public descriptionId = `popover-description-${Math.random()
    .toString(36)
    .substr(2, 9)}`;

  constructor(private elementRef: ElementRef) {}

  public togglePopover() {
    this.isOpen.set(!this.isOpen());
    if (this.isOpen()) {
      this.resetImageState();
    }
  }

  public closePopover() {
    this.isOpen.set(false);
  }

  public onImageLoad() {
    this.imageLoading.set(false);
    this.imageError.set(false);
  }

  public onImageError() {
    this.imageLoading.set(false);
    this.imageError.set(true);
  }

  private resetImageState() {
    this.imageLoading.set(true);
    this.imageError.set(false);
  }

  public getPopoverPositionClasses(): string {
    switch (this.position()) {
      case 'top':
        return 'bottom-full mb-2 left-1/2 transform -translate-x-1/2';
      case 'bottom':
        return 'top-full mt-2 left-1/2 transform -translate-x-1/2';
      case 'left':
        return 'right-full mr-2 top-1/2 transform -translate-y-1/2';
      case 'right':
        return 'left-full ml-2 top-1/2 transform -translate-y-1/2';
      default:
        return 'top-full mt-2 left-1/2 transform -translate-x-1/2';
    }
  }

  public getArrowPositionClasses(): string {
    switch (this.position()) {
      case 'top':
        return 'top-full left-1/2 transform -translate-x-1/2 -mt-1 border-t border-l border-gray-200';
      case 'bottom':
        return 'bottom-full left-1/2 transform -translate-x-1/2 -mb-1 border-b border-r border-gray-200';
      case 'left':
        return 'left-full top-1/2 transform -translate-y-1/2 -ml-1 border-t border-l border-gray-200';
      case 'right':
        return 'right-full top-1/2 transform -translate-y-1/2 -mr-1 border-b border-r border-gray-200';
      default:
        return 'bottom-full left-1/2 transform -translate-x-1/2 -mb-1 border-b border-r border-gray-200';
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  public onEscapeKey(event: KeyboardEvent) {
    if (this.isOpen()) {
      this.closePopover();
      event.preventDefault();
    }
  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: Event) {
    if (
      this.isOpen() &&
      !this.elementRef.nativeElement.contains(event.target)
    ) {
      this.closePopover();
    }
  }
}
